// Schlanke Darstellung fuer Geraete ohne Grafikbeschleunigung (Schul-PCs,
// Remote-/VDI-Sitzungen, Software-Rendering).
//
// Anlass: Am 08.10.2026 flackerten Profilkarten und Skills auf einem Windows-
// Schulrechner, nicht auf iPad, iPhone und MacBook. Weichzeichner
// (backdrop-filter) unter fest stehenden Leisten und 3D-Ebenen der Karten sind
// auf der CPU teuer; dort wird jedes Bild neu berechnet.
//
// Wirkung: Die Klasse `eo-lite` am <html>-Element (Regeln am Ende von index.css)
// schaltet Weichzeichner und 3D-Flip ab. Auf Geraeten mit Grafikkarte aendert
// sich nichts.
//
// Umschalten von Hand (bleibt im Browser gespeichert):
//   ?lite=1  schlanke Darstellung erzwingen
//   ?lite=0  schlanke Darstellung verbieten (auch bei erkanntem Software-Rendering)
//   ?lite=auto  Handwahl loeschen, wieder automatisch erkennen

const STORAGE_KEY = 'eo-lite';
const SOFTWARE_RENDERER = /swiftshader|llvmpipe|softpipe|software|basic render|microsoft basic|warp/i;

const readStored = () => {
  try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
};

const writeStored = (value) => {
  try {
    if (value === null) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, value);
  } catch (e) { /* Speicher gesperrt: Handwahl gilt nur fuer diesen Aufruf */ }
};

// true, wenn WebGL fehlt oder ueber eine Software-Ebene laeuft.
export const detectSoftwareRendering = () => {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return true;
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    const renderer = info ? String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL) || '') : '';
    const lose = gl.getExtension('WEBGL_lose_context');
    if (lose) lose.loseContext();
    return SOFTWARE_RENDERER.test(renderer);
  } catch (e) {
    return false;
  }
};

export const resolveLiteGraphics = () => {
  if (typeof window === 'undefined') return false;

  let override = null;
  try {
    override = new URLSearchParams(window.location.search).get('lite');
  } catch (e) { /* ohne Query-Auswertung weiter */ }
  if (override === '1' || override === '0') writeStored(override);
  else if (override === 'auto') writeStored(null);

  const stored = readStored();
  if (stored === '1') return true;
  if (stored === '0') return false;

  const prefersLessTransparency = typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-transparency: reduce)').matches;
  return prefersLessTransparency || detectSoftwareRendering();
};

// Einmal beim Start aufrufen (index.js), vor dem ersten Rendern.
export const applyRenderTier = () => {
  const lite = resolveLiteGraphics();
  if (lite && typeof document !== 'undefined') document.documentElement.classList.add('eo-lite');
  return lite;
};

// Fuer Komponenten: Stand zum Zeitpunkt des Aufrufs, gelesen aus der Klasse.
export const isLiteGraphics = () => typeof document !== 'undefined'
  && document.documentElement.classList.contains('eo-lite');
